export enum ChartResolution {
  Day = 'DAY',
  Week = 'WEEK',
  Month = 'MONTH',
}

export enum StatsChartType {
  ScoreDistribution = 'SCORE_DISTRIBUTION',
  ScoreTotal = 'SCORE_TOTAL',
  EmissionCo2Distribution = 'EMISSION_CO2_DISTRIBUTION',
  EmissionCo2Total = 'EMISSION_CO2_TOTAL',
  TripsDistribution = 'TRIPS_DISTRIBUTION',
  TripsTotal = 'TRIPS_TOTAL',
  MileageDistribution = 'MILEAGE_DISTRIBUTION',
  MileageTotal = 'MILEAGE_TOTAL',
  // mileage distribution for day of a week
  MileageDistributionDOW = 'MILEAGE_DISTRIBUTION_DOW',
  TriggersOverspeedingDistribution = 'TRIGGERS_OVERSPEEDING_DISTRIBUTION',
  TriggersAbsolute = 'TRIGGERS_ABSOLUTE',
  TriggersRelative = 'TRIGGERS_RELATIVE',
}

export enum CollectionType {
  Score = 'SCORE',
  Emissions = 'EMISSIONS',
  Trips = 'TRIPS',
  Mileage = 'MILEAGE',
  Triggers = 'TRIGGERS',
}

export enum EChartsType {
  Line = 'line',
  Bar = 'bar',
  Radar = 'radar',
}

export const EchartsTypeMap: {
  [key in StatsChartType]: EChartsType | undefined;
} = {
  SCORE_DISTRIBUTION: EChartsType.Line,
  SCORE_TOTAL: undefined,
  EMISSION_CO2_DISTRIBUTION: EChartsType.Line,
  EMISSION_CO2_TOTAL: undefined,
  TRIPS_DISTRIBUTION: EChartsType.Line,
  TRIPS_TOTAL: undefined,
  MILEAGE_DISTRIBUTION: EChartsType.Line,
  MILEAGE_DISTRIBUTION_DOW: EChartsType.Bar,
  MILEAGE_TOTAL: undefined,
  TRIGGERS_OVERSPEEDING_DISTRIBUTION: EChartsType.Bar,
  TRIGGERS_RELATIVE: EChartsType.Radar,
  TRIGGERS_ABSOLUTE: EChartsType.Radar,
};

export const EchartsTitleMap: {
  [key in StatsChartType]: string;
} = {
  SCORE_DISTRIBUTION: 'ScorePage.ScoreDistribution',
  SCORE_TOTAL: 'Statistics.ScorePage.Total',
  EMISSION_CO2_DISTRIBUTION: 'Statistics.EmissionPage.CO2Distribution',
  EMISSION_CO2_TOTAL: 'Statistics.EmissionPage.Total',
  TRIPS_DISTRIBUTION: 'Statistics.TripsPage.NumberOfTrips',
  TRIPS_TOTAL: 'Statistics.TripsPage.Total',
  MILEAGE_DISTRIBUTION: 'Statistics.MileagePage.MileageDistribution',
  MILEAGE_TOTAL: 'Statistics.MileagePage.Total',
  MILEAGE_DISTRIBUTION_DOW: 'Statistics.MileagePage.MileageDistributionDOW',
  TRIGGERS_OVERSPEEDING_DISTRIBUTION:
    'Statistics.TriggersPage.OverSpeedDistribution',
  TRIGGERS_ABSOLUTE: 'Statistics.TriggersPage.Absolute',
  TRIGGERS_RELATIVE: 'Statistics.TriggersPage.Relative',
};

export enum GroupType {
  Department = 'DEPARTMENT',
  Company = 'COMPANY',
  Global = 'GLOBAL',
}

export const companyColorPreset = '--red-60';
export const globalColorPreset = '--green-80';

export const groupColorTokenPreset: { [key: number]: string } = {
  0: '--orange-20',
  1: '--graphite-20',
  2: '--red-30',
  3: '--steel-100',
  4: '--orange-70',
  5: '--graphite-80',
  6: '--red-60',
  7: '--steel-70',
  8: '--teal-40',
  9: '--green-50',
  10: '--blue-30',
  11: '--purple-40',
  12: '--teal-60',
  13: '--green-80',
  14: '--blue-70',
  15: '--purple-70',
};
